const PROJECTS_DATA = [
  {
    id: 1,
    name: "Dev Community Clone",
    desc: "Dev Community is Full-stack Blogging Application build with MERN. This project is inspired from dev.to website, I enjoyed and learned a lot while building this. I used React for Front-end User interface, Redux for State Management, Redux thunk for Asynchronous tasks, Express for Backend server, MongoDB Atlas for Database, JSON Web Tokens for Authentications, SHA256 Hashing Algo to hash password and Firbase for storage.",
    image: "/images/1.jpg",
    tech: [
      { class: "fab fa-react", name: "React" },
      { class: "/images/redux.svg", name: "Redux" },
      { class: "/images/redux.svg", name: "Express" },
      { class: "/images/redux.svg", name: "Node" },
      { class: "/images/redux.svg", name: "MongoDB" },
      { class: "/images/firebase.svg", name: "Firebase" },
    ],
    date: "Jun, 2021",
    link: "",
    type: "WebApp",
  },
  {
    id: 2,
    name: "TrackerX",
    desc: "TrackerX is a Full-stack MERN Application for managing finances. I build this App for personal use, I was not able to find an app for managing finances which can fulfill my needs So, I decided to build my own 😋. User can track their expenses and income with various Filter Options. I used React-Bootstrap to build User Interface, Redux to manage state, Express for Backend API server, MongoDB Atlas as Database.",
    image: "/images/2.jpg",
    tech: [
      { class: "fab fa-react", name: "React" },
      { class: "/images/redux.svg", name: "Redux" },
      { class: "/images/redux.svg", name: "Express" },
      { class: "/images/redux.svg", name: "Node" },
      { class: "/images/redux.svg", name: "MongoDB" },
    ],
    date: "--",
    link: "Coming Soon...",
    type: "WebApp",
  },
  {
    id: 3,
    name: "doubts - freelance place",
    desc: "Doubts is freelance platform for teachers or anyone having any skill. This platform provide a direct connection with skilled teachers. User can search for skill which they want to learn and then they have to select a teacher and set-up a video call or chat with them.",
    image: "/images/3.jpg",
    tech: [
      { class: "fab fa-react", name: "React" },
      { class: "/images/redux.svg", name: "Redux" },
      { class: "/images/redux.svg", name: "Express" },
      { class: "/images/redux.svg", name: "Node" },
      { class: "/images/redux.svg", name: "MongoDB" },
    ],
    date: "Coming Soon...",
    link: "Coming Soon...",
    type: "WebApp & Website",
  },
  {
    id: 4,
    name: "My Portfolio 2021",
    desc: "This is the website that I love the most. This is my Portfolio website 2021. This website contains about me and my projects. I used React and GSAP to build this website.",
    image: "/images/4.jpg",
    tech: [
      { class: "fab fa-react", name: "React" },
      { class: "fab fa-react", name: "GSAP" },
    ],
    date: "--",
    link: "--",
    type: "WebSite",
  },
  {
    id: 5,
    name: "Netflix Clone",
    desc: "Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.Netflix clone is a landing page website built using react.",
    image: "/images/5.jpg",
    tech: [
      { class: "fab fa-react", name: "React" },
      { class: "/images/redux.svg", name: "Redux" },
    ],
    date: "Jan, 2021",
    link: "",
    type: "WebApp",
  },
  {
    id: 6,
    name: "My Portfolio 2019",
    desc: "This was my portfolio website in 2019.",
    image: "/images/6.jpg",
    tech: [
      { class: "fab fa-react", name: "React" },
      { class: "/images/redux.svg", name: "Redux" },
    ],
    date: "Aug, 2019",
    link: "",
    type: "WebSite",
  },
  {
    id: 7,
    name: "TrackIt",
    desc: "TrackIt is web application by which users can track Covid Cases and Weather on interacting with Map.",
    image: "/images/7.jpg",
    tech: [
      { class: "fab fa-js", name: "JS" },
      { class: "fab fa-html", name: "HTML" },
      { class: "fab fa-css", name: "CSS" },
    ],
    date: "--",
    link: "",
    type: "WebApp",
  },
  {
    id: 8,
    name: "BANKIST App",
    desc: "Bankist App is a small bank managment application built using Javascript.",
    image: "",
    tech: ["Reactjs", "GSAP", "API"],
    date: "",
    link: "",
    type: "WebSite and Branding",
  },
];

export default PROJECTS_DATA;
